import { apiUrl } from '../config/apiBase';
import { persistAndBroadcastAccessToken } from './accessTokenEvents';

let inFlight = null;

/**
 * Новый access JWT по httpOnly refresh cookie (POST /api/auth/refresh).
 * При отсутствии/протухшей cookie сервер отвечает 401 — для гостя это норма, возвращаем `null` (не бросаем ошибку).
 * @returns {Promise<string|null>}
 */
export async function refreshAccessToken() {
    if (inFlight) return inFlight;

    inFlight = (async () => {
        let res;
        try {
            res = await fetch(apiUrl('/api/auth/refresh'), {
                method: 'POST',
                credentials: 'include',
            });
        } catch (networkErr) {
            if (process.env.NODE_ENV === 'development') {
                console.warn(
                    '[auth] Не удалось связаться с API (запустите backend: npm run backend или npm start):',
                    networkErr?.message || networkErr
                );
            }
            return null;
        }
        const data = await res.json().catch(() => ({}));
        if (res.status === 401 || res.status === 429) {
            return null;
        }
        if (!res.ok) {
            const err = new Error(typeof data?.message === 'string' ? data.message : 'Сессия истекла');
            err.status = res.status;
            throw err;
        }
        if (!data?.token) {
            const err = new Error('Нет токена');
            err.status = 500;
            throw err;
        }
        persistAndBroadcastAccessToken(data.token);
        return data.token;
    })();

    try {
        return await inFlight;
    } finally {
        inFlight = null;
    }
}
